import _ from 'lodash';

import {
  FETCH_ACCESS_REQUESTS,
  FETCHED_ACCESS_REQUESTS,
  UNDO_REQUEST,
  APPROVE_REQUEST,
  APPROVED_REQUEST,
  REJECT_REQUEST,
  REJECTED_REQUEST,
} from '../constants';

const INITIAL_STATE = {
  requests: {},
  loadingRequests: false,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FETCH_ACCESS_REQUESTS:
      return { ...state, loadingRequests: true };
    case FETCHED_ACCESS_REQUESTS: {
      const accessRequests = _.mapKeys(payload, 'recId');
      return { ...state, requests: accessRequests, loadingRequests: false };
    }
    case APPROVE_REQUEST: {
      const newState = _.setWith(_.clone(state), `requests[${payload}].status`, 'pending', _.clone);
      return { ...state, ...newState };
    }
    case APPROVED_REQUEST: {
      const newState = _.setWith(_.clone(state), `requests[${payload}].status`, 'approved', _.clone);
      return { ...state, ...newState };
    }
    case REJECT_REQUEST: {
      const newState = _.setWith(_.clone(state), `requests[${payload}].status`, 'pending', _.clone);
      return { ...state, ...newState };
    }
    case REJECTED_REQUEST: {
      const newState = _.setWith(_.clone(state), `requests[${payload}].status`, 'rejected', _.clone);
      return { ...state, ...newState };
    }
    case UNDO_REQUEST: {
      const newState = _.setWith(_.clone(state), `requests[${payload}].status`, null, _.clone);
      return { ...state, ...newState };
    }
    default:
      return state;
  }
};
